import { React, useState, useEffect } from 'react';
import GeoGebraP from '../components/GeoGebraP';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import axiosapi from '../api/axiosapi';
import useAuth from '../hooks/useAuth';
import useAxiosPrivate from '../hooks/useAxiosPrivate';
// import '../App.css';
import GetProblemInfo from '../components/GetProblemInfo';
// import ViewMyAnswer from '../components/ViewMyAnswer';
import ProblemStatDescription from '../components/ProblemStatDescription';
import UserSolvingStat from '../components/UserSolvingStat';
import 'katex/dist/katex.min.css';
import { InlineMath } from 'react-katex';

const splitContent = (sentence) => {
    const InlineMathRegex = /<InlineMath[^>]*>(.*?)<\/InlineMath>/g;
    const matches = sentence.matchAll(InlineMathRegex);
    let lastIndex = 0;
    const contentArray = [];
  
    for (const match of matches) {
        const InlineMathContent = <InlineMath key={lastIndex} math={match[1]} />;
        const restOfContent = sentence.substring(lastIndex, match.index);
    
        contentArray.push(restOfContent, InlineMathContent);
        lastIndex = match.index + match[0].length;
    }
  
    if (lastIndex < sentence.length) {
        contentArray.push(sentence.substring(lastIndex));
    }
  
    return <div>{contentArray}</div>;
};

const DifficultyProblem = ()=> {
    const navigateto=useNavigate();
    const {dcProbID}=useParams();
    const {auth, setAuth} = useAuth();
    const {difficultyCategoryCode, problemCode, difficultyCategoryTitle, dcPhase} = useLocation().state;
    const location = useLocation();
    const {problem, problemPoemTitle, problemPoem, isPoem, errP} = GetProblemInfo({"problemID": problemCode});
    // const {isMyAnswer, latestAnswer, myAnswerList, errMyAns} = ViewMyAnswer({"problemCode": problemCode});
    const {useStat} = UserSolvingStat({"problemCode": problemCode});
    const [isFirst, setIsFirst] = useState(false);
    const [isLast, setIsLast] = useState(false);
    const [prevProblem, setPrevProblem] = useState('');
    const [nextProblem, setNextProblem] = useState('');
    const axiosPrivate = useAxiosPrivate();
    // const [prevProblemId, setPrevProblemId] = useState('');
    // const [nextProblemId, setNextProblemId] = useState('');
    const [prevUrlAdd, setPrevUrlAdd] = useState();
    const [nextUrlAdd, setNextUrlAdd] = useState();
    const [categoryProblems, setCategoryProblems]=useState([]);
    const [count, setCount] = useState(0);
    const [count2, setCount2] = useState(0);
    // const [error2, setError2]=useState();
    const [errFD, setErrFD] = useState(false);
    const [problemOrder, setProblemOrder] = useState();
    const [poemFlag,setPoemFlag] = useState(false);
    const [loading, setLoading] = useState(true);
    const [showPoem, setShowPoem] = useState(false);

    useEffect(()=> {
        const fetchDifficultyCategoryProblemList = async () => {
            try {
                const response = await axiosPrivate.get('/difficultycategory/problem/list/', {
                     params: {
                            dcCategory: difficultyCategoryCode
                     },
                     withCredentials: true
                });
                setCategoryProblems(response.data);
                setCount(count+1);
            } catch (e) {
                setErrFD(true);
                // setError2(e);
                // if (e.response) {
                //     console.log(e.response.data);
                //     console.log(e.response.status);
                //     console.log(e.response.headers);
                // } else {
                //     console.log(`Error: ${e.message}`);
                // }
            }
        }
        fetchDifficultyCategoryProblemList();

        const fetchToken = async () => {
            try {
                const response = await axiosapi.post('/refresh-token', {
                            withCredentials: true
                    });
                setAuth(prev => {
                    // console.log(JSON.stringify(prev));
                    // console.log(response.data.access_token);
                    return { 
                    ...prev, 
                    userRole1: response.data.userRole1,
                    userRole2: response.data.userRole2,
                    accessToken: response.data.access_token 
                    }
                });
            } catch {
                setAuth(prev => {
                    // console.log(JSON.stringify(prev));
                    // console.log(response.data.access_token);
                    return { 
                    ...prev, 
                    accessToken: null 
                    }
                }); // 로그인 안 된 상태
            } finally {
                setLoading(false);
            }
        }
        !auth?.accessToken && fetchToken();

    },[difficultyCategoryCode]);

    useEffect(() => {
        const categorySetting = () => {
            categoryProblems.map(cate => {
                if(cate.problemCode === problemCode) {
                    setProblemOrder(cate.problemOrder);
                    setCount2(count2+1);
                }
            })
        }
        categorySetting();
    },[count, dcProbID])

    useEffect(() => {
        const getMoveToProblem = () => {
            if (problemOrder === 1) {
                setIsFirst(true);
                setPrevProblem(problemCode);
                setPrevUrlAdd(dcProbID);
            } else {
                setIsFirst(false);
                categoryProblems.map(cate => {
                    if(cate.problemOrder === problemOrder-1) {
                        setPrevProblem(cate.problemCode);
                        setPrevUrlAdd(cate.urlAdd);
                    }
                })
            }
            if (problemOrder === categoryProblems.length) {
                setIsLast(true);
                setNextProblem(problemCode);
                setNextUrlAdd(dcProbID);
            } else {
                setIsLast(false);
                categoryProblems.map(cate => {
                    if(cate.problemOrder === problemOrder+1) {
                        setNextProblem(cate.problemCode);
                        setNextUrlAdd(cate.urlAdd)
                    }
                })
            }
        }
        getMoveToProblem();
    },[count2, dcProbID])

    useEffect(() => {
        if (problem.problemPoemTitle) {
            setPoemFlag(true)
        } else {
            setPoemFlag(false)
        }
    },[problem.problemPoemTitle])

    console.log("problemPoemTitle of problem", problem.problemPoemTitle);
    console.log("problemPoemTitle", problemPoemTitle);
    console.log("problemPoem of problem", problem.problemPoem);
    console.log("problemPoem", problemPoem);
    console.log("isPoem", isPoem);
    console.log("poemFlag", poemFlag);
    console.log("problemOrder", problemOrder);

    if (errP || errFD) {
        return (
            <div className="problem">
                <p>"문제를 다운로드하지 못했습니다. 다시 시도해 주세요."</p>
                <button 
                    className='button'
                    onClick={() => navigateto(-1, {replace: true})}
                >
                    이전화면으로 돌아가기
                </button>
            </div>
        )
    } else if (auth?.accessToken === null && problemOrder > 2) {
        return (
            <div className="problem">
                {navigateto("/login", {state:{"from": location}}, {replace: true})}
            </div>
        )
    }

    if (problemPoem && problemPoem.length > 1) {
        return(
            <div className="problem" key={problem.problemCode}>
                <div className="content-fit">
                    <h5 style={{fontWeight:"bolder", color:"orange" ,marginTop:"22px", marginBottom:"15px"}}>{difficultyCategoryTitle}</h5>
                    
                    <ProblemStatDescription 
                        topCategoryTitle="작도와 함께 두뇌 활성화하기"
                        problemTitle={problem.problemTitle} 
                        problemDescription={problem.problemDescription}
                        problemId={problem.problemCode}
                        useStat={useStat}
                        problemType={problem.problemType}
                        maxPoint={problem.maxPoint}
                        // problemPoemTitle={problemPoemTitle}
                        // problemPoem={problemPoem}
                    /> 
                    {problem && <GeoGebraP
                        title={problem.problemTitle}
                        // description={problem.description}
                        idIn={problem.problemCode}
                        customToolBarIn={problem.customToolBar}
                        allowStyleBarIn={problem.allowStyleBar}
                        ggbBase64In={problem.problemContent}
                        problemType={problem.problemType}
                        showToolBarHelpIn={problem.showToolBarHelp}
                        enableLabelDragIn={problem.enableLabelDrag}
                        enableShiftDragZoomIn={problem.enableShiftDragZoom}
                    />}
                    <div className='horizontal-flex-container'>
                        {isFirst 
                            ? null 
                            : <button 
                                className='button' 
                                onClick={() => navigateto(`/difficultyproblem/${difficultyCategoryCode}${prevUrlAdd}`, {state:{
                                    "difficultyCategoryCode": difficultyCategoryCode,
                                    "problemCode": prevProblem,
                                    "difficultyCategoryTitle": difficultyCategoryTitle,
                                    "dcPhase": dcPhase
                                }})}
                            >
                                이전 문제
                            </button>
                        } 
                        {isLast 
                            ? null 
                            : <button 
                                className='button' 
                                onClick={() => navigateto(`/difficultyproblem/${difficultyCategoryCode}${nextUrlAdd}`, {state:{
                                    "difficultyCategoryCode": difficultyCategoryCode,
                                    "problemCode": nextProblem,
                                    "difficultyCategoryTitle": difficultyCategoryTitle,
                                    "dcPhase": dcPhase
                                }})}
                            >
                                다음 문제
                            </button>
                        }
                        {problem.problemFileType === 1 && (problem.problemType === 1 || problem.problemType === 2 || problem.problemType === 4 || problem.problemType === 6 || problem.problemType === 7 || problem.problemType === 701 || problem.problemType === 10 || problem.problemType === 11 || problem.problemType === 12) 
                            ? <button 
                                    className='button'
                                    onClick={
                                        () => auth?.accessToken
                                            ? navigateto(`/difficultyproblem/my/s/list`, {state:{
                                                    "difficultyCategoryCode": difficultyCategoryCode,
                                                    "problemCode": problemCode,
                                                    "difficultyCategoryTitle": difficultyCategoryTitle,
                                                    "problem": problem,
                                                    "useStat": useStat,
                                                    "isFirst": isFirst,
                                                    "isLast": isLast,
                                                    "prevProblem": prevProblem,
                                                    "prevUrlAdd": prevUrlAdd,
                                                    "nextProblem": nextProblem,
                                                    "nextUrlAdd": nextUrlAdd,
                                                    "dcProbID": dcProbID,
                                                    "dcPhase": dcPhase
                                                }})
                                            : navigateto("/login", {state:{"from": location}}, {replace: true})
                                    }
                                >
                                    내 풀이보기
                                </button>
                            : null
                        }
                        {<button
                                className='button'
                                onClick={() => setShowPoem(prev => !prev)}
                            >
                                {showPoem ? '시적인 확장 감추기' : ' 시적인 확장 보기'}
                            </button>
                        }
                    </div>
                    <br/>
                    {showPoem && <div style={{marginLeft:"30px"}}>
                        <p><b>{problemPoem && problemPoem.length > 1 && problemPoemTitle !== "NaN" && splitContent(problemPoemTitle)}</b></p>
                        {problemPoem && problemPoem.length > 2 && problemPoem.map(poem => {
                            return (
                                <div>{poem.trim().length>0 ? splitContent(poem) : <br/>}</div>
                                // <div>{poem}<br/></div>
                            )
                        })}
                    </div>}
                </div>
                
            </div>
        );
    } else {
        return(
            <div className="problem" key={problem.problemCode}>
                <div className="content-fit">
                    <h5 style={{fontWeight:"bolder", color:"orange" ,marginTop:"22px", marginBottom:"15px"}}>{difficultyCategoryTitle}</h5>
                    
                    <ProblemStatDescription 
                        topCategoryTitle="작도와 함께 두뇌 활성화하기"
                        problemTitle={problem.problemTitle} 
                        problemDescription={problem.problemDescription}
                        problemId={problem.problemCode}
                        useStat={useStat}
                        problemType={problem.problemType}
                        maxPoint={problem.maxPoint}
                    /> 
                    {problem && <GeoGebraP
                        title={problem.problemTitle}
                        // description={problem.description}
                        idIn={problem.problemCode}
                        customToolBarIn={problem.customToolBar}
                        allowStyleBarIn={problem.allowStyleBar}
                        ggbBase64In={problem.problemContent}
                        problemType={problem.problemType}
                        showToolBarHelpIn={problem.showToolBarHelp}
                        enableLabelDragIn={problem.enableLabelDrag}
                        enableShiftDragZoomIn={problem.enableShiftDragZoom}
                    />}
                    <div className='horizontal-flex-container'>
                        {isFirst 
                            ? null 
                            : <button 
                                className='button' 
                                onClick={() => navigateto(`/difficultyproblem/${difficultyCategoryCode}${prevUrlAdd}`, {state:{
                                    "difficultyCategoryCode": difficultyCategoryCode,
                                    "problemCode": prevProblem,
                                    "difficultyCategoryTitle": difficultyCategoryTitle,
                                    "dcPhase": dcPhase
                                }})}
                            >
                                이전 문제
                            </button>
                        } 
                        {isLast 
                            ? null 
                            : <button 
                                className='button' 
                                onClick={() => navigateto(`/difficultyproblem/${difficultyCategoryCode}${nextUrlAdd}`, {state:{
                                    "difficultyCategoryCode": difficultyCategoryCode,
                                    "problemCode": nextProblem,
                                    "difficultyCategoryTitle": difficultyCategoryTitle,
                                    "dcPhase": dcPhase
                                }})}
                            >
                                다음 문제
                            </button>
                        }
                        {problem.problemFileType === 1 && (problem.problemType === 1 || problem.problemType === 2 || problem.problemType === 201 || problem.problemType === 4 || problem.problemType === 6 || problem.problemType === 7 || problem.problemType === 701 || problem.problemType === 10 || problem.problemType === 11 || problem.problemType === 12) 
                            ? <button 
                                    className='button'
                                    onClick={
                                        () => auth?.accessToken
                                            ? navigateto(`/difficultyproblem/my/s/list`, {state:{
                                                    "difficultyCategoryCode": difficultyCategoryCode,
                                                    "problemCode": problemCode,
                                                    "difficultyCategoryTitle": difficultyCategoryTitle,
                                                    "problem": problem,
                                                    "useStat": useStat,
                                                    "isFirst": isFirst,
                                                    "isLast": isLast,
                                                    "prevProblem": prevProblem,
                                                    "prevUrlAdd": prevUrlAdd,
                                                    "nextProblem": nextProblem,
                                                    "nextUrlAdd": nextUrlAdd,
                                                    "dcProbID": dcProbID,
                                                    "dcPhase": dcPhase
                                                }})
                                            : navigateto("/login", {state:{"from": location}}, {replace: true})
                                    }
                                >
                                    내 풀이보기
                                </button>
                            : null
                        }
                    </div>
                </div>
                
            </div>
        );
    }
};

export default DifficultyProblem;
